module.exports = new __parcel__URL__("soil-moisture-main.b84b1d8d.jpg").toString();